// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import MainArea from '../components/MainArea';
import { mainAreaSelector } from '../selectors';

type PropsType = {
  forwardRef: unknown;
  betslipReference: string;
  x: number;
  y: number;
};

const MainAreaContainer = (ownProps: PropsType) => {
  let data = null;

  const selectedProps = useSelector(
    (state) => {
      data = mainAreaSelector(state, ownProps);
      return data;
    },
    () => data !== null,
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <MainArea {...enhancedProps} />;
};

export default MainAreaContainer;
